import { Button, Form } from "antd";
import React, { useEffect, useState } from "react";
import { FormIteamCommercial } from "../Form/project/IteamFormConclued/FormIteamCommercial";
import { FormIteamOperation } from "../Form/project/IteamFormConclued/FormIteamOperation";
import { FormIteamFinance } from "../Form/project/IteamFormConclued/FormIteamFinance";
import { ContainerTab } from "./ContainerTab";
import { ContainerModal } from "./ContainerModal";
import { typeForDetailsProyect } from "../../types/typeModalDetailsProject";
import dayjs from "dayjs";

const tabs = [
	{
		name: "Operaciones",
		component: <FormIteamOperation disabled={true} />,
	},
	{
		name: "Finanzas",
		component: <FormIteamFinance disabled={true} />,
	},
	{
		name: "Comercial",
		component: <FormIteamCommercial disabled={true} />,
	},
];

export const ContainerReadProjectDetails = ({ dataForm = {}, isProjectRed = false, commentCancel = [], closeModalDetails, activeModalDetailsProject }) => {

	const [form] = Form.useForm();

	useEffect(() => {
		const jsonForm = dataForm.reduce((acc, { category, subCategory, comment }) => {
			if (subCategory === undefined) {
				return { ...acc, [category]: comment };
			} else {
				return {
					...acc,
					[category]: {
						...acc[category],
						[subCategory]: comment,
					},
				};
			}
		}, {});
		form.setFieldsValue(jsonForm);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [tabSelect, setTabSelect] = useState(0);

	const setTabIdSelect = (id) => {
		setTabSelect(id);
	};

	return (
		<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
			<ContainerModal
				title={"Lectura de proyecto concluido"}
				actionButton={() => {
					closeModalDetails();
				}}
				className={"w-[500px]"}
			>
				<div>
					<ContainerTab tabs={tabs} selectTab={tabSelect} onClickTab={setTabIdSelect}>
						<Form form={form} className="w-full h-full mt-4">
							{tabs[tabSelect].component}
						</Form>
						{isProjectRed && (
							<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
								<Button
									htmlType="button"
									onClick={() => {
										activeModalDetailsProject(typeForDetailsProyect.projectRed, { disabled: true });
									}}
								>
									Análisis de proyectos en rojo
								</Button>
							</div>
						)}
						{commentCancel.length > 0 && (
							<div className="w-full h-[40px] overflow-hidden flex justify-end gap-4">
								<Button
									htmlType="button"
									onClick={() => {
										const { comment, canceledAt } = commentCancel[0];
										activeModalDetailsProject(typeForDetailsProyect.continueCancelarProyect, {
											disabled: true,
											title: "Comentarios cancelados",
											dataForm: {
												canceledAt: dayjs(canceledAt, "YYYY/MM/DD"),
												comment: comment,
											},
										});
									}}
								>
									Comentarios de cancelado
								</Button>
							</div>
						)}
					</ContainerTab>
				</div>
			</ContainerModal>
		</div>
	);
};
